import {
  TICKET_OPTIONS_CARD_COLLAPSE,
  TICKET_OPTIONS_CARD_EXPAND
} from "@app/modules/results/constants/action-types";

import type { TicketOptionsCardName } from "../selection-options.constants";

export function trackTicketOptionsCardCollapse(
  id: string,
  card_name: TicketOptionsCardName
) {
  return {
    type: TICKET_OPTIONS_CARD_COLLAPSE,
    id,
    card_name
  };
}

export function trackTicketOptionsCardExpand(
  id: string,
  card_name: TicketOptionsCardName
) {
  return {
    type: TICKET_OPTIONS_CARD_EXPAND,
    id,
    card_name
  };
}
